import { isBrowser } from "utils/infrastructure/ssg-utils"

export function getRootNode() {
    if (!isBrowser()) return null
    return document.querySelector("#__next")
}
